module.exports = __webpack_public_path__ + "static/img/collection1.939f1208.png";